export default "__VITE_ASSET__FwHNHXl3__"